<div class="container">
  <div class="menu-item">
    <button mat-button (click)="navigate('create-campaign')"
    [class.selected-menu-item]="isRouteSelected('create-campaign')">
      <div>
        <mat-icon>add_circle_outline</mat-icon>
        <span>צור קמפיין</span>
      </div>
    </button>
  </div>

  <div class="menu-item">
    <button mat-button (click)="navigate('campaign-status')"
    [class.selected-menu-item]="isRouteSelected('campaign-status')">
      <div>
        <mat-icon>list_alt</mat-icon>
        <span>קמפיינים</span>
      </div>
    </button>
  </div>

  <mat-expansion-panel hideToggle class="menu-item">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="menu-item">
            <button mat-button >
              <div>
                <mat-icon>smart_toy</mat-icon>
                <span>אווטארים</span>
              </div>
            </button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="menu-item">
        <button mat-button (click)="navigate('avatars/avatars-list')" [class.selected-menu-item]="isRouteSelected('avatars-list')">
          <div>
            <span>שליפת אווטארים</span>
          </div>
        </button>
      </div>
      @if(isAdmin()) {
      <div class="menu-item">
        <button mat-button (click)="navigate('avatars/avatars-gardening-chart')" [class.selected-menu-item]="isRouteSelected('avatars-gardening-chart')">
          <div>
            <span>סטטוס גינון</span>
          </div>
        </button>
      </div>
      <div class="menu-item">
        <button mat-button (click)="navigate('avatars/launch-avatar')" [class.selected-menu-item]="isRouteSelected('app-launch-avatar')">
          <div>
            <span>הזנק אווטאר </span>
          </div>
        </button>
      </div>
      <div class="menu-item">
        <button mat-button (click)="navigate('avatars/app-novnc-tasks')" [class.selected-menu-item]="isRouteSelected('app-novnc-tasks')">
          <div>
            <span>צפיה באמולטורים</span>
          </div>
        </button>
      </div>
      <!-- <div class="menu-item">
        <button mat-button (click)="navigate('avatars/create-avatar')" [class.selected-menu-item]="isRouteSelected('create-avatar')">
          <div>
            <span>צור אווטארים</span>
          </div>
        </button>
      </div> -->
      }
  </mat-expansion-panel>

  <div class="menu-item">
    <button mat-button (click)="navigate('groups-dashboard')" [class.selected-menu-item]="isRouteSelected('groups-dashboard')">
      <div>
        <mat-icon>groups</mat-icon>
        <span>קבוצות</span>
      </div>
    </button>
  </div>

  @if(isAdmin()) {
  <mat-expansion-panel hideToggle class="menu-item">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="menu-item">
            <button mat-button>
              <div>
                <mat-icon>admin_panel_settings</mat-icon>
                <span>מנהל מערכת</span>
              </div>
            </button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="menu-item">
        <button mat-button (click)="openDashboard()">
          <div>
            <span>דשבורד</span>
          </div>
        </button>
      </div>
  </mat-expansion-panel>
  }

</div>
